import { intervalToDuration } from 'date-fns';

const MILLISECONDS_MULTIPLIER = 1000;

export const getTimeFormat = (value: number, unit: 'seconds' | 'milliseconds' = 'seconds') => {
  if (!value) {
    return;
  }

  const timeInMs = unit === 'seconds' ? value * MILLISECONDS_MULTIPLIER : value;
  const duration = intervalToDuration({ start: 0, end: timeInMs });

  if (duration.days && duration.days > 0) {
    if (duration.hours === 0 && duration.minutes === 0) {
      return `${duration.days}d`;
    } else if (duration.minutes === 0) {
      return `${duration.days}d ${duration.hours}h`;
    } else if (duration.hours === 0) {
      return `${duration.days}d ${duration.minutes}m`;
    }
    return `${duration.days}d ${duration.hours}h ${duration.minutes}m`;
  }

  if (duration.hours === 0) {
    return `${duration.minutes}m`;
  }

  if (duration.minutes === 0) {
    return `${duration.hours}h`;
  }

  return `${duration.hours}h ${duration.minutes}m`;
};
